/**
 * Crypto coin icons using official logos from CoinGecko CDN.
 * Falls back to a coloured initial circle if the image fails to load.
 */
import { useState } from "react";

const ICON_URLS = {
  TON: "https://assets.coingecko.com/coins/images/17980/standard/ton_symbol.png",
  TRX: "https://assets.coingecko.com/coins/images/1094/standard/tron-logo.png",
  BNB: "https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png",
  USDT: "https://assets.coingecko.com/coins/images/325/standard/Tether.png",
};

const FALLBACK_COLORS = {
  TON: "#0098EA",
  TRX: "#EF0027",
  BNB: "#F3BA2F",
  USDT: "#26A17B",
};

export const CryptoIcon = ({ code, size = 24, className = "" }) => {
  const [errored, setErrored] = useState(false);
  const url = ICON_URLS[code];

  if (!url || errored) {
    return (
      <div
        className={`rounded-full flex items-center justify-center text-white font-bold ${className}`}
        style={{
          width: size,
          height: size,
          background: FALLBACK_COLORS[code] || "#71717A",
          fontSize: size * 0.4,
        }}
      >
        {code === "USDT" ? "₮" : code?.charAt(0)}
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={code}
      width={size}
      height={size}
      onError={() => setErrored(true)}
      className={`rounded-full ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
      loading="lazy"
    />
  );
};

export default CryptoIcon;
